import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllBuilderProducts(id) {
    const data = useStaticQuery(graphql`
        fragment Product on builder_RaneProductData{
            url
            image
            hoverImage
            name
            description
            categories
            badgeList
            downloads
            legacy
            releaseDateValue
            gtin
        }
        query{
            allBuilderModels{
                raneProduct(limit: 100, options: { cachebust: true }){
                    id
                    data{
                        ...Product
                    }
                }
            }
        }
    `)

    const arr = data.allBuilderModels.raneProduct
        .map(({ id, data }) => ({ id, ...data }))
    
    if(id) return arr.find(_ => _.id === id)
    
    return arr.sort((a, b) => {
        const x = a?.releaseDateValue
        const y = b?.releaseDateValue

        if(!x && !y) return 0

        if(x && !y) return -1
        if(!x && y) return 1

        if(x > y) return -1
        if(x < y) return 1

        return 0
    })
}
